/**
 * Generated by orval v8.2.0 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */

/**
 * Billing interval
 */
export type CreateCheckoutRequestBillingInterval = typeof CreateCheckoutRequestBillingInterval[keyof typeof CreateCheckoutRequestBillingInterval];


export const CreateCheckoutRequestBillingInterval = {
  monthly: 'monthly',
  yearly: 'yearly',
} as const;
